export function toAlpha(num, upper = false) {
    let result = '';
    let n = num;
    while (n > 0) {
        const rem = (n - 1) % 26;
        result = String.fromCharCode((upper ? 65 : 97) + rem) + result;
        n = Math.floor((n - 1) / 26);
    }
    return result || (upper ? 'A' : 'a');
}
export function toRoman(num, upper = false) {
    const lookup = [
        ['M', 1000], ['CM', 900], ['D', 500], ['CD', 400],
        ['C', 100], ['XC', 90], ['L', 50], ['XL', 40],
        ['X', 10], ['IX', 9], ['V', 5], ['IV', 4], ['I', 1]
    ];
    let roman = '';
    let n = num;
    for (const [letter, val] of lookup) {
        while (n >= val) {
            roman += letter;
            n -= val;
        }
    }
    return upper ? roman : roman.toLowerCase();
}
export function getOrderedListMarker(index, listStyleType) {
    const num = index + 1;
    switch (listStyleType) {
        case 'lower-alpha':
            return `${toAlpha(num, false)}. `;
        case 'upper-alpha':
            return `${toAlpha(num, true)}. `;
        case 'lower-roman':
            return `${toRoman(num, false)}. `;
        case 'upper-roman':
            return `${toRoman(num, true)}. `;
        case 'decimal-bracket':
            return `${num}) `;
        case 'lower-alpha-bracket':
            return `${toAlpha(num, false)}) `;
        case 'decimal':
        default:
            return `${num}. `;
    }
}
